// Dedicated Swiper file for Testimonial Block
// Path: assets/scripts/js/blocks/testimonial-swiper.js

import Swiper from 'swiper/bundle';
//import 'swiper/css/bundle';

console.log('⚡ testimonial-swiper.js loaded');

document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll('.testimonial-feed-block .swiper');
  console.log(`🔎 Found ${containers.length} testimonial swiper container(s)`);

  if (!containers.length) return;

  containers.forEach((container, index) => {
    console.log(`➤ Initializing testimonial swiper [${index}]`);

    const next = container.querySelector('.swiper-button-next');
    const prev = container.querySelector('.swiper-button-prev');

    new Swiper(container, {
      loop: true,
      navigation: { nextEl: next, prevEl: prev },
      speed: 2000,
      autoplay: {
        delay: 10000, // slide stays visible for 10 seconds
        disableOnInteraction: false,
      },
      spaceBetween: 16,
      watchOverflow: true,
      keyboard: { enabled: true },
      a11y: {
        enabled: true,
        containerMessage: 'Testimonial carousel',
        slideLabelMessage: 'Slide {{index}} of {{slidesLength}}',
      },
      on: {
        init() {
          console.log(`✅ testimonial swiper #${index} initialized`);
        },
      },
    });
  });
});